module.exports = __webpack_public_path__ + "assets/img/logo.min.dd6e60a6.png";